import { useEffect, useState } from "react";

const ViewAllRecords = () => {
    const DB_NAME = 'assignmentDatabase';
    const DB_VERSION = 1;
    const STORE_NAME = 'assignment store';

    const [data,setData]= useState([]);

    useEffect(()=>{
     let openRequest = indexedDB.open(DB_NAME,DB_VERSION);

     openRequest.onupgradeneeded = (event)=>{
        let db = event.target.result;
        db.createObjectStore(DB_NAME,{keypath: 'id'});
     };

     openRequest.onsuccess = (event)=>{
        let db = event.target.result;
        let transaction = db.transaction(STORE_NAME,'readonly');
        let objectStore = transaction.objectStore(STORE_NAME);
        let request = objectStore.getAll();

        request.onsuccess = (event)=>{
            setData(event.target.result);
        }
     };
    },[]);



    return (  
        <div className="view_all_records">
          {data && data.map((records) =>(
               <div className="viewContainer" key={records.id}>
                <h2>Assignment Year:{records.assignmentYear}</h2>
                <h3>Name: {records.name}</h3>
                <h3>Country: {records.country}</h3>
                <h3>City: {records.city}</h3> <br/>
                <h3>MESSAGES: {records.messages}</h3> <br/>
                <h3>SOULS WON: {records.soulsWon}</h3> <br/>
                <h3>PRAYER TIME: {records.prayerTime}</h3> <br/>
                <h3>Fasting Count: {records.fastingcount}</h3> <br/>
                <h3> <strong>BOOKS READ:</strong> {records.booksCompleted}</h3> <br/>
                <h3> <strong>BIBLE BOOKS READ:</strong> {records.bibleBooks}</h3> <br/>
                <h3> <strong>Other Records:</strong> {records.otherRecords}</h3>
               </div>
            
            ))}
        </div>
    );
}
export default ViewAllRecords;